import React from "react";

const SupportTicketsList = React.lazy(() => import('src/pages/support_tickets/SupportTicketsList'));
const SupportTicketDetail = React.lazy(() => import('src/pages/support_tickets/SupportTicketDetail'));

/* The detail path is declared BEFORE the list path, the same way every other
   module here does it: the router matches in order, and a bare
   /dashboard/support-tickets registered first would swallow the id segment. */
const routes = [
    { path: '/dashboard/support-tickets/:id', name: 'Ticket', element: SupportTicketDetail },
    { path: '/dashboard/support-tickets', name: 'Customer Service', element: SupportTicketsList },
];

export default routes;
